import React from 'react';
import { OrderedList } from '../../../../../common/display/orderedList/OrderedList';
import { ImageSource } from '../../../../../common/display/imageSource/ImageSource';
import HowItWorkSection1Png from '../images/HowItWorkSection1.png';
import HowItWorkSection1Webp from '../images/HowItWorkSection1.webp';
import HowItWorkSection2Png from '../images/HowItWorkSection2.png';
import HowItWorkSection2Webp from '../images/HowItWorkSection2.webp';
import HowItWorkSection3Png from '../images/HowItWorkSection3.png';
import HowItWorkSection3Webp from '../images/HowItWorkSection3.webp';
import { useIntl } from '@/i18n';

const HowItWorksTab = () => {
  const { t } = useIntl();
  const Item = OrderedList.Item;

  return (
    <div className='margin-bottom-xxl'>
      <OrderedList>
        <Item
          image={
            <ImageSource
              image={HowItWorkSection1Png}
              imageWebp={HowItWorkSection1Webp}
              imageAlt={t({
                id: 'benefits.tenantProtectionServices.modal.howItWorks.image1',
                defaultMessage: 'paper and pen',
              })}
              sizes='100px'
            />
          }
          text={
            <>
              <span className='font-body-medium-bold'>
                {t({
                  id: 'benefits.tenantProtectionServices.modal.howItWorks.title1',
                  defaultMessage: 'Aktiviere MieterEngel',
                })}
              </span>
              <br />
              {t({
                id: 'benefits.tenantProtectionServices.modal.howItWorks.paragraph1',
                defaultMessage:
                  'Ab dem ersten Tag Zugang zu MieterEngel erhalten. Mit der Anmeldung im Portal bekommst du einen persönlichen Anwalt oder Anwältin zugeteilt. Du kannst entscheiden, ob dein Anliegen schriftlich oder telefonisch geprüft werden soll.',
              })}
            </>
          }
        />
        <Item
          image={
            <ImageSource
              image={HowItWorkSection2Png}
              imageWebp={HowItWorkSection2Webp}
              imageAlt={t({
                id: 'benefits.tenantProtectionServices.modal.howItWorks.image2',
                defaultMessage: 'opened letter',
              })}
              sizes='100px'
            />
          }
          text={
            <>
              <span className='font-body-medium-bold'>
                {t({
                  id: 'benefits.tenantProtectionServices.modal.howItWorks.title2',
                  defaultMessage: 'Stelle deine Frage',
                })}
              </span>
              <br />
              {t({
                id: 'benefits.tenantProtectionServices.modal.howItWorks.paragraph2',
                defaultMessage:
                  'Dein Mietproblem – deine individuelle Beratung. Dafür werden je nach Fall verschiedene Dokumente benötigt. Wir lassen dich wissen, welche Dokumente zu deinem Mietproblem hochzuladen sind (z.B. Mietvertrag, Nebenkostenrechnung, Schreiben vom Vermieter, etc.). Das geht direkt über den Browser oder über das Smartphone. Achte darauf, dass Fotos und Scans gut lesbar sind!',
              })}
            </>
          }
        />
        <Item
          image={
            <ImageSource
              image={HowItWorkSection3Png}
              imageWebp={HowItWorkSection3Webp}
              imageAlt={t({
                id: 'benefits.tenantProtectionServices.modal.howItWorks.image3',
                defaultMessage: 'download',
              })}
              sizes='100px'
            />
          }
          text={
            <>
              <span className='font-body-medium-bold'>
                {t({
                  id: 'benefits.tenantProtectionServices.modal.howItWorks.title3',
                  defaultMessage: 'Rechtsberatung von Partneranwält:innen',
                })}
              </span>
              <br />
              {t({
                id: 'benefits.tenantProtectionServices.modal.howItWorks.paragraph3',
                defaultMessage:
                  'Schriftlich oder per Telefon. Egal wie voll dein Terminkalender oder wie lang deine To-do-List ist. Individueller Mieterschutz direkt auf dich zugeschnitten. Du entscheidest, ob dein Anliegen schriftlich oder telefonisch geprüft werden soll. Sobald alle Unterlagen hochgeladen sind, erhältst du innerhalb von wenigen Tagen eine Antwort. Solltest du lieber telefonisch mit dem Partneranwalt oder der Partneranwältin sprechen wollen, erhältst du einen minutengenauen Termin, den du ganz bequem einplanen kannst.',
              })}
            </>
          }
        />
      </OrderedList>
    </div>
  );
};

export default HowItWorksTab;
